module.exports = __webpack_public_path__ + "img/ICEF.0f79393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ICEF.png
// module id = 1149
// module chunks = 1